import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Form } from "react-form";
import { map } from "lodash";
import TextFields from "../UI/TextFiled";
import SwitchToggle from "../UI/SwitchToggle";
import ReactPaginate from "react-paginate";
import {
  getFinanceDrivers,
  getSearchFinanceDrivers,
  downloadFinanceDrivers
} from "../../store/actions/financeDrivers";
import { connect } from "react-redux";

class FinanceDrivers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: "",
      DriversLength: 0
    };
  }
  async componentDidMount() {
    await this.props.getFinanceDrivers(this.props.auth.token, 1);
    let DriversReportShow = [];
    map(this.props.financeDrivers.results, data => {
      DriversReportShow.push(data);
    });
    if (this.state.DriversLength <= DriversReportShow.length) {
      this.setState({ DriversLength: DriversReportShow.length });
    }
  }
  handleInput = e => {
    this.setState({ searchValue: e.target.value });
  };
  handleClick = pagenumber => {
    this.props.getFinanceDrivers(
      this.props.auth.token,
      pagenumber.selected + 1
    );
  };
  onSearch = () => {
    this.props.getSearchFinanceDrivers(
      this.props.auth.token,
      this.state.searchValue
    );
  };
  onDownload = async () => {
    const response = await this.props.downloadFinanceDrivers(
      this.props.auth.token,
      this.state.searchValue
    );
    const replaceData = response.payload.replace(/purse/g, "pending_amount");
    const url = window.URL.createObjectURL(new Blob([replaceData]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Drivers.csv");
    link.click();
  };
  render() {
    const drivers = map(this.props.financeDrivers.results, data => data);
    let currentsDriversCount =
      this.state.DriversLength > 0 ? this.state.DriversLength : drivers.length;
    let pageCount = Math.ceil(
      this.props.financeDrivers.count / currentsDriversCount
    );

    return (
      <React.Fragment>
        <div className="page-title">
          <div className="container">
            <div className="row flex-center-y justify-between">
              <div className="col-xs-9">
                <h1 className="color-grey">Drivers</h1>
              </div>
              <div className="col-xs-3">
                <Form onSubmit={this.submitted}>
                  {formApi => (
                    <form
                      onSubmit={formApi.submitForm}
                      className="search"
                      onChange={this.handleInput}
                    >
                      <TextFields type="text" hintText="Search" />
                      <button
                        className="no-style search-btn pointer"
                        onClick={this.onSearch}
                      >
                        <i className="fa fa-search" />
                      </button>
                    </form>
                  )}
                </Form>
              </div>
            </div>
          </div>
        </div>
        <div className="container box py-15">
          <div className="table mt-20 withHover">
            {/* <Link to="/finance/driver">Driver Single item</Link> */}
            <table>
              <thead>
                <tr>
                  <th>Drier ID</th>
                  <th>Driver First Name</th>
                  <th>Driver Last Name</th>
                  <th>Pending Amount</th>
                  <th>Agreed Deposit</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {map(this.props.financeDrivers.results, row => {
                  return (
                    <tr key={row.id}>
                      <td
                        onClick={() =>
                          this.props.history.push(`/finance/drivers/${row.id}`)
                        }
                      >
                        {row.id}
                      </td>
                      <td
                        onClick={() =>
                          this.props.history.push(`/finance/drivers/${row.id}`)
                        }
                      >
                        {row.first_name}
                      </td>
                      <td
                        onClick={() =>
                          this.props.history.push(`/finance/drivers/${row.id}`)
                        }
                      >
                        {row.last_name}
                      </td>
                      <td
                        onClick={() =>
                          this.props.history.push(`/finance/drivers/${row.id}`)
                        }
                      >
                        {row.purse} SAR
                      </td>
                      <td
                        onClick={() =>
                          this.props.history.push(`/finance/drivers/${row.id}`)
                        }
                      >
                        {row.agreed_deposit} SAR
                      </td>
                      <td>
                        <SwitchToggle
                          notForm
                          toggled={row.status === "free"}
                          field="is_active"
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {pageCount > 1 && (
            <ReactPaginate
              onPageChange={this.handleClick}
              pageCount={pageCount}
              initialPage={0}
              breakClassName={"break-me"}
              containerClassName={"pagination"}
              subContainerClassName={"pages pagination"}
              activeClassName={"active"}
              previousLabel={<i className="fa fa-chevron-left" />}
              nextLabel={<i className="fa fa-chevron-right" />}
            />
          )}
          <div className="text-right mt-20">
            <Link
              to="#"
              className="flex-align-y font-sm w-800"
              onClick={this.onDownload}
            >
              <i className="fa fa-download mr-10" />
              Download Excel File
            </Link>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
function mapStateToProps(state) {
  return {
    financeDrivers: state.financeDrivers,
    auth: state.auth
  };
}
export default connect(
  mapStateToProps,
  {
    getFinanceDrivers,
    getSearchFinanceDrivers,
    downloadFinanceDrivers
  }
)(FinanceDrivers);



// WEBPACK FOOTER //
// ./src/components/Finance/Drivers.js